module.exports = __webpack_public_path__ + "img/xmasParty5.860dff09.jpg";